import React, { useMemo } from 'react'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import { toggleNewCreatedEvent } from 'routing/fetchingfunction/user/user.action'
import {
  selectAvailableEvents,
  selectAvailableEventsNewCreatedAsEntityAdapter,
  selectLastCreatedBanner,
  selectBannersCreateBanner,
  selectPassedTestsCreateBanner,
  selectClassBannerCategoriesCreateBanner,
} from 'routing/fetchingfunction/user/user.reducer'

import OrangeAddIcon from 'assets/icon/orange-add.svg'

// TODO
const COLOR_SCHEME = {
  1: {
    color: 'text-[#EF4343]',
    bgColor: 'bg-[#FFDCDC]',
  },
  2: {
    color: 'text-white',
    bgColor: 'bg-[#F79009]',
  },
}

const TimeSlotWrapper = ({
  children: { props },
  mainCategories = [],
  notUseLastCategory = false,
  category,
  value,
}) => {
  const dispatch = useDispatch()
  const lastBanner = useSelector(selectLastCreatedBanner)
  const newCreatedEvents = useSelector(selectAvailableEventsNewCreatedAsEntityAdapter)
  const banners = useSelector(selectBannersCreateBanner)
  const events = useSelector(selectAvailableEvents)

  // const passedTests = useSelector(selectPassedTestsCreateBanner);

  // const selectedCategories = passedTests.map((test) => test.category);

  const timeDetector = useMemo(() => {
    const key = `${moment(value).format('YYYY-MM-DD')}:${moment(value).format('H')}`
    if (!events[key] && !newCreatedEvents[key]) {
      return {
        isEmpty: true,
      }
    }

    if (notUseLastCategory && !category) {
      return {
        isEmpty: true,
      }
    }

    const id = events[key]?.class_banner || newCreatedEvents[key].class_banner
    const bannerId =
      category || banners.find((banner) => banner.id === id)?.class_banner_category?.id || 1

    const foundCategory = mainCategories.find((e) => e.id === bannerId)

    return {
      ...COLOR_SCHEME[!!events[key] ? 1 : 2],
      ...(events[key] && { hasInitialEvent: true }),
      title: foundCategory?.title || foundCategory?.name,
    }
  }, [lastBanner, events, newCreatedEvents])

  const getClassBanner = () => {
    try {
      return lastBanner?.id
    } catch (err) {
      return null
    }
  }

  const onAddEvent = () => {
    if (!timeDetector.hasInitialEvent) {
      dispatch(
        toggleNewCreatedEvent({
          class_banner: getClassBanner(),
          day: moment(value).format('YYYY-MM-DD'),
          slot: moment(value).format('H'),
          notes: '',
        })
      )
    }
  }

  return props.children ? (
    moment(value).format('HH:mm')
  ) : (
    <div
      onClick={onAddEvent}
      className={`group absolute w-full h-full ${timeDetector.hasInitialEvent ? 'pointer-events-none' : 'cursor-pointer'} ${timeDetector.isEmpty ? 'hover:bg-[#FFD4B5]' : `${timeDetector.bgColor}`} flex items-center justify-center`}
    >
      {timeDetector.isEmpty ? (
        <img src={OrangeAddIcon} alt="Add" className="hidden group-hover:block" />
      ) : (
        <p className={`text-sm font-semibold text-center ${timeDetector.color}`}>
          {timeDetector.title}
        </p>
      )}
    </div>
  )
}

export default React.memo(TimeSlotWrapper)
